export default {
  'lang.english': 'ఇంగ్లీష్',
  'lang.hindi': 'హిందీ',
  'lang.telugu': 'తెలుగు',

  'nav.master': 'డాష్‌బోర్డ్',
  'nav.dashboard': 'అవలోకనం',
  'nav.customers': 'కస్టమర్లు',
  'nav.finance': 'ఫైనాన్స్',
  'nav.loans': 'చేతి రుణాలు',
  'nav.accounts': 'అకౌంట్స్',
  'nav.report': 'రిపోర్టులు',
  'nav.audit': 'ఆడిట్ లాగ్‌లు',
  'nav.erp': 'ఫైనాన్స్ ERP',
  'nav.consultancy': 'కన్సల్టెన్సీ',
  'nav.expenses': 'ఖర్చులు',
  'nav.employees': 'ఉద్యోగులు & జీతం',
  'nav.settings': 'సెట్టింగ్‌లు',
  'nav.home': 'హోమ్',
  'nav.clients': 'క్లయింట్లు',
  'nav.financeShort': 'ఫైనాన్స్',
  'nav.loansShort': 'రుణాలు',
  'nav.clientsShort': 'కస్టమర్',
  'nav.settingsShort': 'సెట్',
  'nav.workspace': 'వర్క్‌స్పేస్',
  'nav.collections': 'వసూళ్లు',
  'nav.support': 'సపోర్ట్',
  'nav.contact': 'సంప్రదించండి',
  'nav.businessHours': 'వ్యాపార గంటల డెస్క్',
  'nav.billingCollections': 'బిల్లింగ్ & వసూళ్లు',

  'common.save': 'సేవ్ చేయండి',
  'common.saved': 'సేవ్ అయింది',
  'common.cancel': 'రద్దు చేయండి',
  'common.export': 'ఎగుమతి',
  'common.exportFile': 'ఫైల్ ఎగుమతి చేయండి',
  'common.search': 'వెతకండి',
  'common.searchWorkspace': 'వర్క్‌స్పేస్ వెతకండి…',
  'common.back': 'వెనక్కి',
  'common.profile': 'ప్రొఫైల్',
  'common.actions': 'చర్యలు',
  'common.entryDate': 'ఎంట్రీ తేదీ',
  'common.logout': 'లాగ్ అవుట్',
  'common.borrower': 'రుణగ్రహీత',
  'common.facilities': 'సౌకర్యాలు',
  'common.principal': 'మూలధనం',
  'common.collected': 'వసూలు',
  'common.outstanding': 'బకాయి',
  'payment.howWePaid': 'మేము ఎలా చెల్లించాము (పంపిణీ)',
  'payment.howTheyPaid': 'వారు ఎలా చెల్లించారు (సేకరణ)',
  'payment.via': 'చెల్లింపు మార్గం',
  'payment.cash': 'నగదు',
  'payment.online': 'బ్యాంక్',
  'payment.split': 'నగదు + బ్యాంక్',
  'payment.cashAmount': 'నగదు మొత్తం (₹)',
  'payment.bankAmount': 'బ్యాంక్ మొత్తం (₹)',
  'payment.splitTotalHint': 'నగదు + బ్యాంక్ = ₹{sum} (₹{total}కి సమానం కావాలి)',
  'payment.selectBank': 'కంపెనీ బ్యాంక్ ఎంచుకోండి',
  'payment.paidBy': 'చెల్లించినవారు / సూచన',
  'payment.cashCollections': 'నగదు సేకరణ',
  'payment.bankCollections': 'బ్యాంక్ సేకరణ',
  'payment.cashDisbursements': 'నగదు పంపిణీ',
  'payment.bankDisbursements': 'బ్యాంక్ పంపిణీ',
  'payment.cashTaken': 'నగదు స్వీకరించబడింది',
  'payment.cashGiven': 'నగదు ఇవ్వబడింది',
  'payment.accountCredited': 'బ్యాంక్ క్రెడిట్',
  'payment.accountDebited': 'బ్యాంక్ డెబిట్',
  'payment.collectionsIn': 'వసూళ్లు లోపల',
  'payment.loanDisbursed': 'ఇచ్చిన రుణం',
  'payment.addBankInSettings': 'ఆన్‌లైన్ ట్రాకింగ్ కోసం సెట్టింగ్‌లు → బ్యాంక్‌లలో ఖాతాలు జోడించండి.',
  'payment.selectBankRequired': 'ఆన్‌లైన్ చెల్లింపు కోసం బ్యాంక్ ఎంచుకోండి',
  'payment.paidByRequired': 'చెల్లింపుదారు లేదా లావాదేవీ సూచన నమోదు చేయండి',
  'common.nextDue': 'తదుపరి చెల్లింపు',
  'common.amount': 'మొత్తం',
  'common.noMatch': 'ఏ కస్టమర్ సరిపోలడు',
  'common.appliesWorkspace': 'ఈ వర్క్‌స్పేస్‌కు మాత్రమే వర్తిస్తుంది',
  'common.add': 'జోడించండి',
  'common.edit': 'సవరించండి',
  'common.delete': 'తొలగించండి',
  'common.new': 'కొత్త',
  'common.close': 'మూసివేయండి',
  'common.submit': 'సమర్పించండి',
  'common.confirm': 'నిర్ధారించండి',
  'common.loading': 'లోడ్ అవుతోంది…',
  'common.status': 'స్థితి',
  'common.date': 'తేదీ',
  'common.phone': 'ఫోన్',
  'common.email': 'ఇమెయిల్',
  'common.name': 'పేరు',
  'common.total': 'మొత్తం',
  'common.view': 'చూడండి',
  'common.filter': 'ఫిల్టర్',
  'common.sort': 'క్రమబద్ధీకరించండి',
  'common.all': 'అన్నీ',
  'common.select': 'ఎంచుకోండి',
  'common.selectLoan': 'రుణం ఎంచుకోండి',
  'common.swipeTable': 'మరిన్ని కాలమ్‌ల కోసం పట్టికను ఎడమ లేదా కుడి స్వైప్ చేయండి',
  'common.readOnly': 'చదవడానికి మాత్రమే',
  'common.finance': 'ఫైనాన్స్',
  'common.handLoans': 'చేతి రుణాలు',
  'common.line': 'లైన్',
  'common.customer': 'కస్టమర్',
  'common.created': 'సృష్టించబడింది',
  'common.updated': 'నవీకరించబడింది',
  'common.records': 'రికార్డులు',
  'common.inPeriod': 'కాలంలో',

  'status.paid': 'చెల్లించబడింది',
  'status.due': 'చెల్లించాలి',
  'status.scheduled': 'షెడ్యూల్ చేయబడింది',
  'status.active': 'సక్రియం',
  'status.seized': 'జప్తు',
  'status.closed': 'మూసివేయబడింది',
  'status.readyToClose': 'మూసివేయడానికి సిద్ధం',
  'status.disabled': 'నిలిపివేయబడింది',
  'status.default': 'డిఫాల్ట్',

  'login.signIn': 'సైన్ ఇన్',
  'login.signingIn': 'సైన్ ఇన్ అవుతోంది…',
  'login.emailPlaceholder': 'ఇమెయిల్ లేదా మొబైల్ నంబర్',
  'login.password': 'పాస్‌వర్డ్',
  'login.showPassword': 'పాస్‌వర్డ్ చూపించండి',
  'login.hidePassword': 'పాస్‌వర్డ్ దాచండి',
  'login.welcome': 'తిరిగి స్వాగతం',
  'login.subtitle': 'మీ వర్క్‌స్పేస్‌లో సైన్ ఇన్ చేయండి',
  'login.createAccount': 'ఖాతా సృష్టించండి',
  'login.enterOtp': 'OTP నమోదు చేయండి',
  'login.otpSubtitle': 'వెనక్కి వెళ్లి ఇమెయిల్ + పాస్‌వర్డ్‌తో సైన్ ఇన్ చేయండి.',
  'login.signUpSubtitle': 'మీ సంస్థ వర్క్‌స్పేస్‌ను సెటప్ చేయండి.',
  'login.or': 'లేదా',
  'login.alreadyHaveAccount': 'ఇప్పటికే ఖాతా ఉందా?',
  'login.newOrganization': 'కొత్త సంస్థ?',
  'login.register': 'నమోదు',
  'login.verifyOtp': 'OTP ధృవీకరించండి',

  'audit.title': 'ఆడిట్ ట్రయిల్',
  'audit.subtitle': 'కార్యాచరణ లాగ్',
  'audit.auditorMode': 'ఆడిటర్ మోడ్ — చదవడానికి మాత్రమే',
  'audit.disclaimer':
    'ఇవి నిర్వహణ రికార్డులు — చట్టపరమైన ఆడిట్ రిపోర్ట్ కాదు.',
  'audit.statTotal': 'మొత్తం ఈవెంట్‌లు',
  'audit.statToday': 'ఈరోజు',
  'audit.statLogins': 'సైన్ ఇన్ / అవుట్',
  'audit.statUpdates': 'అప్‌డేట్‌లు',
  'audit.statSecurity': 'భద్రత',
  'audit.searchPlaceholder': 'యూజర్, లోన్, యాక్షన్ వెతకండి…',
  'audit.refresh': 'రిఫ్రెష్',
  'audit.actionFilter': 'యాక్షన్ రకం',
  'audit.tableTitle': 'కార్యాచరణ లాగ్',
  'audit.events': 'ఈవెంట్‌లు',
  'audit.empty': 'ఇంకా ఆడిట్ ఈవెంట్‌లు లేవు',
  'audit.emptyHint': 'మీ బృందం వర్క్‌స్పేస్ ఉపయోగించినప్పుడు ఈవెంట్‌లు ఇక్కడ కనిపిస్తాయి.',
  'audit.exportTitle': 'ఆడిట్ ట్రయిల్ ఎక్స్‌పోర్ట్',
  'audit.detailTitle': 'ఆడిట్ ఎంట్రీ',
  'audit.actor': 'యూజర్',
  'audit.entity': 'రికార్డ్',
  'audit.reason': 'కారణం',
  'audit.device': 'పరికరం',
  'audit.changes': 'మార్పులు',
  'audit.oldValue': 'పాత విలువ',
  'audit.newValue': 'కొత్త విలువ',
  'audit.action': 'యాక్షన్',
  'audit.summary': 'సారాంశం',
  'audit.prev': 'మునుపటి',
  'audit.next': 'తదుపరి',
} as const;
